<template>
  <div class="d-flex my-2 justify-space-between">
    <div class="w-20 pr-5">
      <v-text-field
        label="Name"
        v-model="name"
        @focus="name = ''"
        @blur="name == '' || name == null ? (name = ' ') : ''"
        @change="$emit('update:name', $event)"
        dense
        outlined
        hide-details
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="w-20 pr-5">
      <v-autocomplete
        :items="categories"
        label="Product Category"
        v-model="productCategoryId"
        @change="$emit('update:productCategoryId', $event)"
        dense
        outlined
        hide-details
        append-icon="apartment"
        item-text="name"
        item-value="id"
      ></v-autocomplete>
    </div>
    <div class="w-20 pr-5">
      <v-autocomplete
        :items="subcategorytypes"
        v-model="productSubcategoryTypeId"
        @change="$emit('update:productSubcategoryTypeId', $event)"
        label="Subcategory Type"
        dense
        hide-details
        append-icon="tab"
        item-text="name"
        item-value="id"
        outlined
      ></v-autocomplete>
    </div>
    <div class="w-20 pr-5">
      <v-select
        :items="actions"
        label="Batch Action"
        append-icon="more_vert"
        class="action_button"
        :disabled="!action"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        hide-details
        outlined
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item class="pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    Delete
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-select>
    </div>
    <div class="w-20 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    productCategoryId: {
      type: String,
      default: null
    },
    productSubcategoryTypeId: {
      type: String,
      default: null
    },
    action: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    categories() {
      let categories = this.$store.state.categories.categories;
      categories.unshift({
        name: "",
        id: null
      });
      return categories;
    },
    subcategorytypes() {
      let subcategoryTypes = this.$store.state.subcategorytypes
        .subcategoryTypes;
      subcategoryTypes.unshift({
        name: "",
        id: null
      });
      return subcategoryTypes;
    }
  },
  async mounted() {
    await this.$store.dispatch("subcategorytypes/LOAD_SUBCATEGORY_TYPES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("categories/LOAD_CATEGORIES", {
      from: 0,
      to: 0
    });
  },
  data() {
    return {
      actions: [
        {
          value: 1,
          text: "Update Status"
        },
        {
          value: 2,
          text: "Update Brand"
        },
        {
          value: 3,
          text: "Update Supplier"
        }
      ]
    };
  }
};
</script>
